import { gql } from "@apollo/client";

export const GET_LATEST_COST_ANALYSIS = gql`
  query GetLatestCostAnalysis {
    getLatestCostAnalysis {
      id
      summary
      previousMonth
      previousMonthTotal
      currentMonth
      currentMonthTotal
      monthOverMonthChange
      monthOverMonthDirection
      mainDriverService
      serviceBreakdownJson
      topDriver
      fastestGrowing
      anomaliesJson
      predictedNextMonth
      predictedTotal
      predictedChangePercent
      predictedDirection
      predictionConfidence
      recommendationAction
      recommendationSuggestion
      createdAt
    }
  }
`;

export const ANALYZE_COSTS = gql`
  mutation AnalyzeCosts {
    analyzeCosts
  }
`;
